import { render, staticRenderFns } from "./SpecimensGrid.vue?vue&type=template&id=73fd839a"
import script from "./SpecimensGrid.vue?vue&type=script&lang=js"
export * from "./SpecimensGrid.vue?vue&type=script&lang=js"
import style0 from "./SpecimensGrid.vue?vue&type=style&index=0&id=73fd839a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports